
/*@jsxRuntime automatic @jsxImportSource react*/
/*prettier-ignore*/
export const attributes = {
  "authors": ["chase-merlin", "ben-milne"],
  "callToAction": {
    "heading": "Get started",
    "subheading": "Create your payments program using Brale Business.",
    "button": "Sign up",
    "ctaUrl": "https://app.brale.xyz/buy/signup/?ref=stablecoin-micropayments",
    "externalUrl": true
  },
  "coverImage": {
    "alt": "Stablecoin micropayments: when $1 is still $1 | Brale Blog",
    "url": "/assets/blog/stablecoin-micropayments/cover.png"
  },
  "date": "2024-08-08",
  "description": "Stablecoins are solving micropayments with up to 97% cost savings over traditional payments. Learn more about supporting micropayments with Brale Business accounts",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_stablecoin-micropayments-when-1-is-still-activity-7227344523553599488-UD2o/",
  "discussTwitter": "https://x.com/brale_xyz/status/1821579382009569575",
  "discussFarcaster": "https://warpcast.com/brale/0x429c6a04",
  "excerpt": "Stablecoins are solving micropayments, with up to 97% cost savings for small transactions.",
  "ogImage": {
    "alt": "Stablecoin micropayments: when $1 is still $1 | Brale Blog",
    "url": "/assets/blog/stablecoin-micropayments/og-image.png"
  },
  "timeOverride": 2,
  "title": "Stablecoin micropayments: when $1 is still $1",
  "costs": [{
    "chainId": "celo",
    "name": "Celo",
    "cost": "$0.0002",
    "explorerUrl": "https://celoscan.io/tx/0xafa2b8e83313945aa941adbc9f38b0cfc6ead413c27be9f332497ed92c34daf5"
  }, {
    "chainId": "stellar",
    "name": "Stellar",
    "cost": "$0.0004",
    "explorerUrl": "https://stellar.expert/explorer/public/op/227193646722039809"
  }, {
    "chainId": "solana",
    "name": "Solana",
    "cost": "$0.001",
    "explorerUrl": "https://solscan.io/tx/5F2c3so5amCYoYQGSH93hfQEYTeNv7t26nhi1rA2bG5rikeGKtFmL8SqJDbCGkRdNMVhuWik7JpmkyH5CEs1J8Fq"
  }, {
    "chainId": "polygon",
    "name": "Polygon",
    "cost": "$0.001",
    "explorerUrl": "https://polygonscan.com/tx/0xba153966a2b305772b97f67d0375a0aaeb2696498d6a4e8e2827464aecc6c59d"
  }, {
    "chainId": "ethereum-classic",
    "name": "Ethereum Classic",
    "cost": "$0.001",
    "explorerUrl": "https://etc.blockscout.com/tx/0x1405fbd609543cbe10cf3b3026d89750bc9307ce42de79dff0e21cf1d1bf9be7"
  }, {
    "chainId": "base",
    "name": "Base",
    "cost": "$0.002",
    "explorerUrl": "https://basescan.org/tx/0x3455c1d87538443f67e4a9a36e644c4197375d9b37bb5175f8cf15dcec604e6d"
  }, {
    "chainId": "arbitrum",
    "name": "Arbitrum",
    "cost": "$0.01",
    "explorerUrl": "https://arbiscan.io/tx/0x85350a0e9f4ba04bf4dba9cfb7edecd6d8d51750d8dc50b0262b509ac22c26e1"
  }, {
    "chainId": "optimism",
    "name": "Optimism",
    "cost": "$0.01",
    "explorerUrl": "https://optimistic.etherscan.io/tx/0xa73cde78a0b48274c205eedf04fed63b0fb01aad0b320038aadf018e58d91fe4"
  }],
  "merchantCost": [{
    "method": "Credit card",
    "fixedFee": "$0.10 - $0.30",
    "variableFee": "1.5% - 3.5%",
    "totalFee": "$0.35"
  }, {
    "method": "ACH",
    "fixedFee": "$0.25",
    "variableFee": "$0",
    "totalFee": "$0.25"
  }, {
    "method": "Onchain",
    "fixedFee": "$0",
    "variableFee": "$0.005",
    "totalFee": "$0.005"
  }],
  "fees": {
    "offchain": [{
      "type": "Wire",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "ACH",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }],
    "onchain": [{
      "type": "USDC",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "USDP",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "PYUSD",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }]
  }
};
import {BlockchainIcon} from "~/components/logos/blockchain";
import {ExternalLink} from "~/components/site/external-link";
import {faArrowUpRight} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    tr: "tr",
    td: "td",
    span: "span",
    h2: "h2",
    img: "img"
  }, props.components);
  return <><_components.p>{"When we previously shared the costs to send $1M in stablecoins onchain, some pointed out that the real impact is even better demonstrated with smaller amounts. Traditional payments have been trying to solve the $1 -> $1 micropayment problem for years without industry-level success. Stablecoins are changing that."}</_components.p>{"\n"}<_components.p>{"Costs to send $1 in stablecoins with Brale Business accounts:"}</_components.p>{"\n"}<div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto text-base m-0"><thead><tr><th className="px-4 w-1/3">{"Chain"}</th><th className="px-4 w-1/3">{"Cost"}</th><th className="px-4 w-1/3">{"Tx"}</th></tr></thead><tbody>{attributes.costs.map(c => <_components.tr key={c.chainId}>
          <_components.td className="px-4 whitespace-nowrap">
            <BlockchainIcon chainId={c.chainId} className="mr-2 inline-block" />
            <_components.span>{c.name}</_components.span>
          </_components.td>
          <_components.td className="px-4">{c.cost}</_components.td>
          <_components.td className="px-4 whitespace-nowrap">
            <ExternalLink title="View on explorer" href={c.explorerUrl} className="flex items-center gap-x-1">
              <_components.span>View on explorer</_components.span>
              <FontAwesomeIcon className="h-4 w-4 text-secondary" icon={faArrowUpRight} />
            </ExternalLink>
          </_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"Stablecoin transactions have become so inexpensive on many chains that supporting near-instant micropayments is now possible."}</_components.p>{"\n"}<_components.h2>{"Stablecoin microtransactions"}</_components.h2>{"\n"}<_components.p>{"Traditional fintech has faced high costs for micropayments, making it challenging for merchants to accept low-dollar payments, support small remittances, and enable new payment models."}</_components.p>{"\n"}<_components.p>{"Consider the cost for a merchant accepting a $1 purchase or donation:"}</_components.p>{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 w-full text-base"><thead><tr><th className="px-4 w-1/4 whitespace-nowrap">{"Payment method"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"Fixed fees"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"Variable fees"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"Total fees"}</th></tr></thead><tbody>{attributes.merchantCost.map(m => <_components.tr key={m.method}>
          <_components.td className="px-4 whitespace-nowrap">{m.method}</_components.td>
          <_components.td className="px-4 whitespace-nowrap">{m.fixedFee}</_components.td>
          <_components.td className="px-4 whitespace-nowrap">{m.variableFee}</_components.td>
          <_components.td className="px-4 whitespace-nowrap">{m.totalFee}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"In international payments, stablecoins help solve the cost and friction of converting to local currencies. Processing a $5 micro-payment from the US to Kenya may cost up to 111% with traditional payments, with end-to-end fees as low as 2% for stablecoins. Using apps like Valora on Celo, stablecoins are supporting micro-task economies emerging markets."}</_components.p>{"\n"}<_components.p>{"Stablecoins also unlock microtransactions models for selling digital goods, content subscriptions, or pay-per-use services where micropayments can be used as an alternative to advertising models."}</_components.p>{"\n"}<_components.h2>{"What about on and offramp fees?"}</_components.h2>{"\n"}<_components.p>{"When comparing stablecoins to traditional payments, it's often pointed out that users still need to deposit and withdraw funds into stablecoins. Brale Business accounts enable businesses to run operations without the onramp and offramp costs usually associated with stablecoins."}</_components.p>{"\n"}{}{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 w-full text-base"><thead><tr><th className="px-4 w-1/3" /><th className="px-4 w-1/3"><span className="whitespace-nowrap">{"Deposit Fee"}</span>{" (Onramp)"}</th><th className="px-4 w-1/3"><span className="whitespace-nowrap">{"Withdraw Fee"}</span>{" (Offramp)"}</th></tr></thead><tbody><tr><td className="px-4 whitespace-nowrap"><strong>{"Offchain"}</strong></td><td className="px-4" /><td className="px-4" /></tr>{attributes.fees.offchain.map(f => <_components.tr key={f.type}>
          <_components.td className="px-4">{f.type}</_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
        </_components.tr>)}<tr><td className="px-4 whitespace-nowrap"><strong>{"Onchain"}</strong></td><td className="px-4" /><td className="px-4" /></tr>{attributes.fees.onchain.map(f => <_components.tr key={f.type}>
          <_components.td className="px-4">
            <_components.img alt={`${f.type} logo`} src={`/assets/stablecoins/${f.type.toLowerCase()}-logo.png`} className="h-6 w-6 inline-block !mr-2" />
            {f.type}
          </_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"With stablecoins, it's now possible to support on-chain operations essentially for free."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "stablecoin-micropayments.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    